module.exports = __webpack_public_path__ + "img/img3.6fc9ba8b.png";